var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeLogoColour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "657px",
    height: "657px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 128.5,222.5 C 187.501,222.333 246.501,222.5 305.5,223C 312.85,224.679 315.683,229.179 314,236.5C 312.5,238 311,239.5 309.5,241C 283.169,241.5 256.835,241.667 230.5,241.5C 230.667,302.168 230.5,362.834 230,423.5C 228.7,431.24 224.2,434.073 216.5,432C 215,430.5 213.5,429 212,427.5C 211.5,365.501 211.333,303.501 211.5,241.5C 182.498,241.667 153.498,241.5 124.5,241C 116.874,232.813 118.207,226.647 128.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#18b6c9",
    d: "M 349.5,222.5 C 408.501,222.333 467.501,222.5 526.5,223C 533.85,224.679 536.683,229.179 535,236.5C 533.5,238 532,239.5 530.5,241C 468.833,241.667 407.167,241.667 345.5,241C 337.874,232.813 339.207,226.647 349.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 347.5,318.5 C 407.834,318.333 468.168,318.5 528.5,319C 535.851,322.434 537.351,327.601 533,334.5C 531.581,335.46 530.081,336.293 528.5,337C 468.167,337.667 407.833,337.667 347.5,337C 340.608,334.149 338.775,329.316 342,322.5C 343.812,321.023 345.645,319.69 347.5,318.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c86720",
    d: "M 349.5,413.5 C 408.501,413.333 467.501,413.5 526.5,414C 533.85,415.679 536.683,420.179 535,427.5C 532.924,430.588 530.091,432.421 526.5,433C 467.5,433.667 408.5,433.667 349.5,433C 342.15,431.321 339.317,426.821 341,419.5C 343.234,416.399 346.067,414.399 349.5,413.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeLogoColour);
export default __webpack_public_path__ + "static/media/TE_Logo_Colour.e646be7b7d0e2bac2de9ef4080519061.svg";
export { ForwardRef as ReactComponent };